import React from 'react';
import { Shield, Plane, Phone, Clock, Car, MapPin } from 'lucide-react';

const WhatsIncluded = () => {
  const included = [
    {
      icon: Shield,
      title: "Seguro de responsabilidad civil y asistencia 24 horas",
      description: "Todos nuestros vehículos cuentan con seguro de ley en la República Dominicana"
    },
    {
      icon: Plane,
      title: "Entrega en el aeropuerto SDQ",
      description: "Sin costo adicional"
    },
    {
      icon: Phone,
      title: "Atención personalizada 24/7 vía WhatsApp",
      description: "Siempre disponibles para ayudarte"
    },
    {
      icon: Clock,
      title: "Período de gracia de 3 horas en la devolución",
      description: "Flexibilidad para tu tranquilidad"
    },
    {
      icon: Car,
      title: "Vehículo entregado limpio y desinfectado",
      description: "Máxima higiene y seguridad"
    },
    {
      icon: MapPin,
      title: "Recomendaciones de rutas, restaurantes y lugares turísticos",
      description: "Te ayudamos a descubrir lo mejor del país"
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-zinc-950">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-20">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-700/20 border border-yellow-600/30 px-4 py-2 mb-6">
            <span className="text-yellow-600 text-sm font-medium">TODO INCLUIDO</span>
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            En los Precios Incluimos
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Transparencia total: esto es lo que obtienes con cada alquiler
          </p>
        </div>

        {/* Included Items Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {included.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={index}
                className="bg-black border border-white/10 p-8 hover:border-yellow-600/50 transition-all duration-300 group"
              >
                <div className="w-16 h-16 bg-yellow-700/20 border border-yellow-600/30 flex items-center justify-center mb-6 group-hover:bg-yellow-700 transition-colors duration-300">
                  <Icon className="w-8 h-8 text-yellow-600 group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-bold text-white mb-3 leading-tight">
                  {item.title}
                </h3>
                <p className="text-white/70 leading-relaxed">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Bottom Note */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-zinc-900 border border-white/10 px-8 py-6 max-w-3xl">
            <p className="text-white/80 text-lg mb-2">
              <span className="text-yellow-600 font-bold">Sin costos ocultos.</span> Lo que ves es lo que pagas.
            </p>
            <p className="text-white/60">
              Todos nuestros vehículos incluyen seguro de ley en la República Dominicana para tu tranquilidad.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatsIncluded;
